// extracted by mini-css-extract-plugin
export default {"container":"BDdo2F6TRCdgqe8dC6Rz","useCustomAddressCTA":"pu32k3swvJVQdDvyw2SQ","useCustomAddressCta":"pu32k3swvJVQdDvyw2SQ"};